/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplementJustification } from './SupplementJustification';
import {
    SupplementJustificationFromJSON,
    SupplementJustificationFromJSONTyped,
    SupplementJustificationToJSON,
    SupplementJustificationToJSONTyped,
} from './SupplementJustification';
import type { SupplementStatus } from './SupplementStatus';
import {
    SupplementStatusFromJSON,
    SupplementStatusFromJSONTyped,
    SupplementStatusToJSON,
    SupplementStatusToJSONTyped,
} from './SupplementStatus';

/**
 * Supplement plus additional details and computed aggregates
 * @export
 * @interface SupplementDetailed
 */
export interface SupplementDetailed {
    /**
     * Unique supplement ID
     * @type {number}
     * @memberof SupplementDetailed
     */
    readonly id: number;
    /**
     * ID of the associated claim
     * @type {number}
     * @memberof SupplementDetailed
     */
    claimId: number;
    /**
     * ID of the associated comparison
     * @type {number}
     * @memberof SupplementDetailed
     */
    comparisonId: number;
    /**
     * Display name (auto-generated as "Supplement
     * @type {string}
     * @memberof SupplementDetailed
     */
    name: string;
    /**
     * 
     * @type {SupplementStatus}
     * @memberof SupplementDetailed
     */
    status: SupplementStatus;
    /**
     * System-managed workflow processing state
     * @type {string}
     * @memberof SupplementDetailed
     */
    workflowStatus: SupplementDetailedWorkflowStatusEnum;
    /**
     * Temporal workflow ID for SSE streaming
     * @type {string}
     * @memberof SupplementDetailed
     */
    workflowId?: string | null;
    /**
     * US state code (e.g., 'TX', 'AK') for building code justifications
     * @type {string}
     * @memberof SupplementDetailed
     */
    state?: string | null;
    /**
     * Overall AI confidence score (0.0 to 1.0)
     * @type {number}
     * @memberof SupplementDetailed
     */
    overallConfidenceScore?: number | null;
    /**
     * ID of the user who created this supplement
     * @type {number}
     * @memberof SupplementDetailed
     */
    readonly createdBy: number;
    /**
     * When the supplement was created
     * @type {Date}
     * @memberof SupplementDetailed
     */
    readonly createdAt: Date;
    /**
     * When the supplement was last updated
     * @type {Date}
     * @memberof SupplementDetailed
     */
    readonly updatedAt: Date;
    /**
     * Array of supplement justifications
     * @type {Array<SupplementJustification>}
     * @memberof SupplementDetailed
     */
    justifications?: Array<SupplementJustification>;
    /**
     * Total number of justifications in this supplement
     * @type {number}
     * @memberof SupplementDetailed
     */
    readonly justificationCount?: number;
    /**
     * Name of the user who created this supplement
     * @type {string}
     * @memberof SupplementDetailed
     */
    readonly createdByName?: string | null;
    /**
     * Snapshot of the comparison data at the time of supplement creation
     * @type {object}
     * @memberof SupplementDetailed
     */
    readonly comparisonSnapshot?: object | null;
    /**
     * When the comparison snapshot was created
     * @type {Date}
     * @memberof SupplementDetailed
     */
    readonly snapshotCreatedAt?: Date | null;
    /**
     * Version of the snapshot format
     * @type {string}
     * @memberof SupplementDetailed
     */
    readonly snapshotVersion?: string | null;
}


/**
 * @export
 */
export const SupplementDetailedWorkflowStatusEnum = {
    Pending: 'pending',
    Processing: 'processing',
    Completed: 'completed',
    Failed: 'failed'
} as const;
export type SupplementDetailedWorkflowStatusEnum = typeof SupplementDetailedWorkflowStatusEnum[keyof typeof SupplementDetailedWorkflowStatusEnum];


/**
 * Check if a given object implements the SupplementDetailed interface.
 */
export function instanceOfSupplementDetailed(value: object): value is SupplementDetailed {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('comparisonId' in value) || value['comparisonId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('workflowStatus' in value) || value['workflowStatus'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SupplementDetailedFromJSON(json: any): SupplementDetailed {
    return SupplementDetailedFromJSONTyped(json, false);
}

export function SupplementDetailedFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementDetailed {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'comparisonId': json['comparisonId'],
        'name': json['name'],
        'status': SupplementStatusFromJSON(json['status']),
        'workflowStatus': json['workflowStatus'],
        'workflowId': json['workflowId'] == null ? undefined : json['workflowId'],
        'state': json['state'] == null ? undefined : json['state'],
        'overallConfidenceScore': json['overallConfidenceScore'] == null ? undefined : json['overallConfidenceScore'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'justifications': json['justifications'] == null ? undefined : ((json['justifications'] as Array<any>).map(SupplementJustificationFromJSON)),
        'justificationCount': json['justificationCount'] == null ? undefined : json['justificationCount'],
        'createdByName': json['createdByName'] == null ? undefined : json['createdByName'],
        'comparisonSnapshot': json['comparisonSnapshot'] == null ? undefined : json['comparisonSnapshot'],
        'snapshotCreatedAt': json['snapshotCreatedAt'] == null ? undefined : (new Date(json['snapshotCreatedAt'])),
        'snapshotVersion': json['snapshotVersion'] == null ? undefined : json['snapshotVersion'],
    };
}

export function SupplementDetailedToJSON(json: any): SupplementDetailed {
    return SupplementDetailedToJSONTyped(json, false);
}

export function SupplementDetailedToJSONTyped(value?: Omit<SupplementDetailed, 'id'|'createdBy'|'createdAt'|'updatedAt'|'justificationCount'|'createdByName'|'comparisonSnapshot'|'snapshotCreatedAt'|'snapshotVersion'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'comparisonId': value['comparisonId'],
        'name': value['name'],
        'status': SupplementStatusToJSON(value['status']),
        'workflowStatus': value['workflowStatus'],
        'workflowId': value['workflowId'],
        'state': value['state'],
        'overallConfidenceScore': value['overallConfidenceScore'],
        'justifications': value['justifications'] == null ? undefined : ((value['justifications'] as Array<any>).map(SupplementJustificationToJSON)),
    };
}

